export default __webpack_public_path__ + "static/Mamre oaks-72d7a8e068419c3751a0c2a3bcd64361.png";